import React, {useState} from "react";
import { Box, Collapse, ListItemText, MenuItem, Stack, SxProps, Typography } from '@mui/material';
import moment from "moment";
import { DateInput, SelectInput } from '@coverright/ui/inputs';

interface Option {
  value: number,
  label: string,
  secondary?: string
}

interface Props {
  options: Option[],
  initialValue?: string,
  value?: string | null,
  onChange: (value: string | null) => void,
  error?: string,
  label: string,
  disabled?: boolean,
  sx?: SxProps
}

export function ConnectClientDateSelector({onChange, value, error, label, options, initialValue, disabled, sx = {}}: Props) {
  const [selectorValue, setSelectorValue] = useState<number | null>(() => {
    if (initialValue !== undefined) {
      const diff = moment(initialValue).diff(moment().startOf('day'), "days");
      const found = options.find(o => o.value === diff);
      if (found) {
        return found.value;
      }
      return 0;
    }
    if (value) {
      const diff = moment(value).diff(moment().startOf('day'), "days");
      const found = options.find(o => o.value === diff);
      if (found) {
        return found.value;
      }
      return 0;
    }
    return null;
  });

  const onSelectorChange = (val: number) => {
    setSelectorValue(val);
    if (val > 0) {
      onChange(moment().add(val, 'days').format('YYYY-MM-DD'));
    }
  }

  return <Box sx={{display: 'flex', flexDirection: 'column', gap: 1, ...sx}}>
    <SelectInput label={label}
                 hideTick
                 disabled={disabled}
                value={selectorValue || ''}
                onChange={event => {
                  onSelectorChange(event.target.value as number);
                }}
                error={Boolean(error)}
                helperText={error}
    >
      {options.map(option => (
        <MenuItem value={option.value} key={option.value}>
          <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} width={1}>
            <span>{option.label}</span>
            {option.secondary && <Typography variant="body2" color="text.secondary">
              {option.secondary}
            </Typography>}
          </Stack>

        </MenuItem>
      ))}
    </SelectInput>

    <Collapse in={selectorValue === 0}>
      <DateInput hideTick
                 label={''}
                 placeholder={'MM / DD / YYYY'}
                 value={/\d{4}-\d{2}-\d{2}/.test(value || '') ? moment(value).format('MM/DD/YYYY') : (value || '')}
                 selectAllOnFocus
                 onChange={e => onChange(e.target.value as string)}
      />
    </Collapse>
  </Box>
}
